export default {
  // 页面标题
  'new_users_retention_by_timezone_title': 'New Users Retention by Timezone',
  // 页面副标题
  // 'new_users_retention_by_timezone_sub_title_country': "This page shows data in the local time zone of the country.",
  // 'new_users_retention_by_timezone_sub_title_zone': "This page shows data in the local time zone of the zone.",
  'new_users_retention_by_timezone_sub_title': "This page shows local timezone data. Data of T(eg: Dec 1st) will be updated on T+2 (Dec 3rd 9:00am UTC +8).",

  // 热力图
  "new_users_retention_by_timezone_Retention_of_New_Users": "Retention of New Users",
  "new_users_retention_by_timezone_column_Register": "Register",
  "new_users_retention_by_timezone_column_Timezone": "Timezone"
}
